import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';

export const FamilyBreachsOfConditionsAnual = () => {
    const { chartData } = useConditionalityChartsDataContext();

    return (
        <SimpleBars
            title={'Proporção de Famílias em Descumprimento de Condicionalidades Acompanhadas (Anual)'}
            horizontal={false}
            subtitles={chartData?.familyBreachsOfConditionsAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.familyBreachsOfConditionsAnual?.map((item) => item.value || 0)}
        />
    );
};
